module.exports = __webpack_public_path__ + "img/login_form_user2.83a1c34d.svg";